export function eventFileUploader() {
  const $files = $('.event-file-upload');
  if (!$files || $files.length === 0) return;

  $files.each((i, el) => {
    const $t = $(el);
    const $input = $t.find('input');
    const $file = $t.find('.event-file-upload-file');
    const $name = $t.find('.event-file-upload-file-name');
    const $remove = $t.find('.event-file-upload-file-remove');

    $input.on('change', (e) => {
      if (e.target.files[0]) {
        $name.text(e.target.files[0].name);
        $file.addClass('show');
      } else {
        $name.text('');
        $file.removeClass('show');
      }
    });

    $remove.on('click', (e) => {
      e.preventDefault();
      $name.text('');
      $file.removeClass('show');
      $input.val(null);
    });
  });
}
